import React from 'react'

import styled from 'styled-components'

import Footer from 'src/modules/organisms/footer/Footer'
import { G2Banner } from 'src/components/blocks/G2Banner'
import { LogostripSection } from 'src/components/blocks/Logostrip'
import Navbar from 'src/modules/organisms/navbar/Navbar'
import { QuoteCardNew } from 'src/components/blocks/QuoteCard'
import {
  Display,
  Paragraph,
  TitleXXL,
  ParagraphSmall,
  Body2Regular,
  TitleH1,
  TitleH4,
  TopHat,
  TitleH2
} from 'src/components/blocks/Typography'
import { VideoContentBlock } from 'src/components/blocks/VideoContentBlock'
import { BrandButton, primaryCTA } from 'src/components/partials/Button'
import ChecklistItem from 'src/components/partials/ChecklistItem'
import SignUpForm from 'src/components/partials/ContactSalesForm'
import { Container } from 'src/components/partials/Container'
import { Grid, Column } from 'src/components/partials/Grid'
import Layout from 'src/components/partials/Layout'
import { ResponsiveSectionWrapper } from 'src/components/partials/Section'
import SEO from 'src/components/partials/Seo'
import UIList from 'src/components/partials/UIList'
import { CheckIconSm } from 'src/components/svg/BrandIcon'
import {
  gaiusParrotmobQuote,
  mayCustomscityQuote,
  sniderClickupQuote,
  mimioQuote
} from 'src/data/quotes'
import { Breakpoints } from 'src/utilities/Breakpoints'
import { BrandColors, BrandTokens } from 'src/utilities/Colors'

const HeaderSectionWrapper = styled(ResponsiveSectionWrapper)`
  min-height: 676px;

  ${Display} {
    max-width: 35ch;
    margin: 2rem auto 1.5rem;
    em {
      font-style: inherit;
      font-weight: 700;
      display: block;
      padding-bottom: 0.5rem;
      font-size: 0.852rem;
      text-transform: uppercase;
      color: ${BrandTokens.textDark50};
      letter-spacing: 0.1em;
    }
  }

  .checklist {
    strong {
      display: block;
      margin-bottom: 0.5rem;
    }

    li {
      margin-bottom: 1rem;
    }
  }
`

const HeaderCopy = styled.div`
  margin-inline: auto;
  /* text-align: center; */
  margin-bottom: 1rem;
  max-width: 85ch;
  margin-inline: auto;

  p {
    max-width: 55ch;
    /* margin-inline: auto; */
    margin-bottom: 2rem;
  }

  @media (min-width: ${Breakpoints.lg}px) {
    margin-bottom: 6rem;
  }

  ul p {
    margin: 0;
  }
`

const FormContainer = styled.div`
  max-width: 500px;
  margin-left: auto;
  margin-right: auto;

  h2 {
    font-size: 1.25rem;
    margin-bottom: 1.5rem;
  }

  @media (min-width: ${Breakpoints.lg}px) {
    margin-left: auto;
    margin-right: unset;
  }
`

const checklist = [
  '<strong>Accelerate time-to-value</strong> Prepare and migrate data to a new system faster with Flatfile’s advanced data mapping and transformation experience your team will love',
  '<strong>Reduce manual effort and data services cost</strong> Reduce the cost and time spent to clean data manually with automated data transformations and in-data team collaboration for review and approval.',
  '<strong>Reduce data errors, increase data quality</strong> Remove data migration blockers and business delays, ensure data is consistent, clean and validated for go-live.'
]

const HeaderSection = () => {
  return (
    <HeaderSectionWrapper paddingLarge='12rem 0 6rem' paddingSmall='6rem 0'>
      <Container>
        <Grid
          columns={{
            md: 2
          }}
          spacing={{
            xs: 1.5
          }}
        >
          <Column>
            <HeaderCopy className='contentWrap'>
              {/* <TopHat marginBottom='.5rem' color={BrandColors.primary}>
                Request a demo
              </TopHat> */}
              <TitleH1
                fontSize={3}
                color={BrandColors.black}
                marginBottom='1rem'
              >
                Efficiently prepare and migrate data for system implementation
                projects
              </TitleH1>
              {/* <Body2Regular>
                Efficiently prepare and migrate data for system implementation
                projects
              </Body2Regular> */}

              <UIList margin='2rem 0 0' className='checklist'>
                {checklist.map((item, index) => (
                  <li key={index}>
                    <ChecklistItem text={item} />
                  </li>
                ))}
              </UIList>
            </HeaderCopy>
          </Column>

          <Column>
            <FormContainer>
              <SignUpForm
                fillUtms={true}
                hsFormId='aa10f4cf-1c45-4c7c-8c70-1bbe0ddf2a5e'
                hsSource='demo'
                showLogo={false}
                theme='light'
                cornerFgColor={BrandTokens.backgroundLight}
                formTitle='See Flatfile in action'
                minHeight='520px'
              />
            </FormContainer>
          </Column>
        </Grid>
      </Container>
    </HeaderSectionWrapper>
  )
}
const GetStartedWrapper = styled(ResponsiveSectionWrapper)`
  position: relative;

  ${Container} {
    position: relative;
    z-index: 2;
  }
`

const CopyWrapper = styled.div`
  max-width: 75ch;
  margin-inline: auto;
  text-align: center;
  display: grid;
  gap: 2rem;
`

const RequestDemo = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 1rem auto;
  gap: 1rem;
  flex-direction: column;

  @media (min-width: ${Breakpoints.sm}px) {
    flex-direction: row;
    align-items: flex-start;
  }

  ${ParagraphSmall} {
    font-size: 0.75rem;
    text-align: center;
    padding-top: 0.5rem;
  }
`

const GetStartedSection = () => (
  <GetStartedWrapper paddingLarge='5rem 0' paddingSmall='3rem 0'>
    <Container>
      <Grid columns={{ sm: 1 }}>
        <Column>
          <CopyWrapper>
            <TitleH2>Evaluating Flatfile for your business needs?</TitleH2>
            <Body2Regular>
              Get a complimentary consultation from one of our experts.
            </Body2Regular>
          </CopyWrapper>
        </Column>

        <Column>
          <RequestDemo>
            <div>
              <BrandButton
                label='Talk to an expert'
                role='primary'
                to='/contact-sales/consult/'
              />
            </div>
          </RequestDemo>
        </Column>
      </Grid>
    </Container>
  </GetStartedWrapper>
)

const SecondaryFeatureSectionWrapper = styled(ResponsiveSectionWrapper)`
  h2 {
    text-align: center;
  }
`

const Flex = styled.div`
  display: flex;
  gap: 4rem;
  align-items: center;
  flex-direction: column;
  margin-bottom: 4rem;

  &:last-child {
    margin-bottom: 0;
  }

  &.swapOrder {
    flex-direction: column-reverse;

    @media (min-width: ${Breakpoints.md}px) {
      flex-direction: row;
    }
  }

  @media (min-width: ${Breakpoints.md}px) {
    margin-bottom: 10rem;
    flex-direction: row;
    justify-content: space-between;
    gap: 4rem;
  }
`

const ContentStackText = styled.div`
  .ctaLink {
    margin-top: 2rem;
    display: inline-block;
  }
  text-align: center;
  max-width: 75ch;

  h3 {
    justify-content: center;
  }

  @media (min-width: ${Breakpoints.md}px) {
    max-width: 40%;
    text-align: left;

    h3 {
      justify-content: flex-start;
    }
  }

  ul li {
    margin-inline: auto;
    max-width: 50ch;
  }

  @media (min-width: ${Breakpoints.md}px) {
    ul li {
      margin-inline: 0;
      max-width: 100%;
    }
  }
`

const ContentStackMedia = styled.div`
  text-align: center;
  max-width: 55ch;

  @media (min-width: ${Breakpoints.md}px) {
    max-width: 50%;
    text-align: left;
  }
`

const ListWrapper = styled.ul`
  margin-top: 2rem;
  margin-left: auto;

  li {
    margin-top: 1.25rem;
    display: flex;
    gap: 1rem;
    align-items: baseline;

    span {
      flex: 1;
    }
  }
`

const SecondaryFeatureSection = () => {
  const ChecklistData = [
    'Speed up migration with AI- powered data transformations',
    'Reduce data errors, increase data quality',
    'Collaborate with internal and external teams during the data preparation process',
    'Reduce manual effort and data services cost',
    'Event-driven architecture that provides the flexibility to create complex workflows'
  ]
  return (
    <SecondaryFeatureSectionWrapper
      backgroundColor={BrandColors.white}
      paddingLarge='6rem 0 3rem'
      paddingSmall='3rem 0'
    >
      <Container>
        <TitleH2 marginBottom='3rem'>
          Data exchange with powerful business impact
        </TitleH2>

        <Flex>
          <ContentStackMedia>
            <img
              src='/img/contentful/5IHTzzUq-data_file_exchange_visual.webp'
              alt='Data File Exchange Visual'
              loading='lazy'
            />
          </ContentStackMedia>

          <ContentStackText>
            {ChecklistData && (
              <ListWrapper>
                {ChecklistData?.map((item, index) => (
                  <li key={index}>
                    <CheckIconSm primaryColor={BrandColors.primary} />
                    <TitleH4
                      fontSize={1.15}
                      as='span'
                      color={BrandColors.black}
                    >
                      {item}
                    </TitleH4>
                  </li>
                ))}
              </ListWrapper>
            )}
          </ContentStackText>
        </Flex>
      </Container>
    </SecondaryFeatureSectionWrapper>
  )
}

const DataMigrationDemoPage = () => {
  return (
    <Layout>
      <Navbar />
      <HeaderSection />
      <LogostripSection
        paddingLarge='2rem 0 4rem'
        paddingSmall='2rem 0 3rem'
        showTopHat
      />
      <SecondaryFeatureSection />
      {/* <VideoContentBlock
        topHatText='FLATFILE INTRO VIDEO'
        title='Check out this quick video to learn more about Flatfile’s core capabilities'
        videoId='08xse0ygi1'
        body='From automated mapping to seamless collaboration, Flatfile has all the tools your company needs to speed up data exchange, securely and cleanly.'
      /> */}
      {/* <GetStartedSection /> */}
      <QuoteCardNew quote={sniderClickupQuote} />
      <G2Banner backgroundColor={BrandColors.black} showCta={false} />
      <Footer variant='secondary' showCta={false} />
    </Layout>
  )
}
export default DataMigrationDemoPage

export const Head = () => (
  <SEO
    description={`Try the Flatfile Data Exchange Platform and build the ideal data file import experience for your users - faster, easier and safer - for free`}
    title='See how Flatfile works'
    robots='hide'
  />
)
